import { useMessageDisplayer } from '@inpart-io/devtools-vue';

import { i18nService } from '@/services/i18n-service';

export function useFileTypeChecker(customSupportedExtensions?: string): {
    supportedExtensions: string[];
    supportedImageExtensions: string[];
    supportedExtensionsAsString: string;
    supportedImageExtensionsAsString: string;
    minFileSize: number;
    maxFileSize: number;
    validateFiles: (files: File[]) => File[];
    validateSingleFile: (file: File) => boolean;
} {
    const maxFileSize = 100 * 1024 * 1024;
    const minFileSize = 1 * 1024;
    const messageDisplayer = useMessageDisplayer();

    const supportedExtensions = ['.jpg', '.jpeg', '.png', '.xls', '.xlsx', '.eml', '.msg', '.ppt', '.pptx', '.doc', '.docx', '.pdf'];
    const supportedImageExtensions = ['.jpg', '.jpeg', '.png'];
    const supportedExtensionsAsString = supportedExtensions.join();
    const supportedImageExtensionsAsString = supportedImageExtensions.join();

    const validateFiles = (files: File[]): File[] => {
        return files.filter((file: File) => {
            return validateSingleFile(file);
        });
    };

    const validateSingleFile = (file: File): boolean => {
        // Check max size
        if (file.size > maxFileSize) {
            messageDisplayer.error(i18nService.t('FILE.ERROR.MAX_SIZE_ERROR', { fileName: file.name }).toString(), false, undefined, 10000);
            return false;
        }
        // Check min size
        if (file.size <= minFileSize) {
            messageDisplayer.error(i18nService.t('FILE.ERROR.MIN_SIZE_ERROR', { fileName: file.name }).toString(), false, undefined, 10000);
            return false;
        }

        const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
        // Check file extension
        if ((customSupportedExtensions !== undefined && !customSupportedExtensions.includes(fileExtension)) || !supportedExtensions.includes(fileExtension)) {
            messageDisplayer.error(i18nService.t('FILE.ERROR.UNSUPPORTED_FILE_TYPE_ERROR', { fileName: file.name }).toString(), false, undefined, 10000);
            return false;
        }

        return true;
    };

    return {
        supportedExtensions,
        supportedImageExtensions,
        supportedExtensionsAsString,
        supportedImageExtensionsAsString,
        maxFileSize,
        minFileSize,
        validateFiles,
        validateSingleFile
    };
}
